import { render, staticRenderFns } from "./PostButton.vue?vue&type=template&id=50eeb90e"
import script from "./PostButton.vue?vue&type=script&lang=js"
export * from "./PostButton.vue?vue&type=script&lang=js"
import style0 from "./PostButton.vue?vue&type=style&index=0&id=50eeb90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports